import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import CreateJob from "@/pages/CreateJob";
import Needs from "@/pages/Needs";
import NeedDetail from "@/pages/NeedDetail";
import CreateNeed from "@/pages/CreateNeed";
import Leaderboard from "@/pages/Leaderboard";
import Businesses from "@/pages/Businesses";
import BusinessDetail from "@/pages/BusinessDetail";
import CreateBusiness from "@/pages/CreateBusiness";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Profile from "@/pages/Profile";
import AdminModeration from "@/pages/AdminModeration";
import Inbox from "@/pages/Inbox";
import GoogleAuthCallback from "@/pages/GoogleAuthCallback";
import CreateListing from "@/pages/CreateListing";
import CreateEvent from "@/pages/CreateEvent";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import "@/App.css";

export default function App() {
  const location = useLocation();
  // Detect Emergent Google Auth return during render (not useEffect — that's too late).
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash && location.hash.includes("session_id=")) {
    return (
      <div className="App">
        <GoogleAuthCallback />
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/marketplace/:id" element={<ListingDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetail />} />
          <Route path="/post/job" element={<CreateJob />} />
          <Route path="/post/job/:id" element={<CreateJob />} />
          <Route path="/needs" element={<Needs />} />
          <Route path="/needs/:id" element={<NeedDetail />} />
          <Route path="/post/need" element={<CreateNeed />} />
          <Route path="/post/need/:id" element={<CreateNeed />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/businesses" element={<Businesses />} />
          <Route path="/businesses/new" element={<CreateBusiness />} />
          <Route path="/business/:slug" element={<BusinessDetail />} />
          <Route path="/businesses/:slug" element={<BusinessDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin/moderation" element={<AdminModeration />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/inbox/:conversationId" element={<Inbox />} />
          <Route path="/post/listing" element={<CreateListing />} />
          <Route path="/post/listing/:id" element={<CreateListing />} />
          <Route path="/post/event" element={<CreateEvent />} />
          <Route path="/post/event/:id" element={<CreateEvent />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </div>
  );
}
